import React from "react";

export default function TermsIcon() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 64.0819V21C2 18.2386 4.23858 16 7 16H55.9391C58.7005 16 60.9391 18.2386 60.9391 21V40.041"
        stroke="#0A4763"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="11.3047"
        y="26.8574"
        width="7.75515"
        height="7.75515"
        rx="1"
        stroke="#0A4763"
        strokeWidth="4"
      />
      <rect
        x="11.3047"
        y="48.5723"
        width="7.75515"
        height="7.75515"
        rx="1"
        stroke="#0A4763"
        strokeWidth="4"
      />
      <line
        x1="27.2656"
        y1="26.4082"
        x2="52.7352"
        y2="26.4082"
        stroke="#0A4763"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <line
        x1="27.2656"
        y1="34.9385"
        x2="38.0004"
        y2="34.9385"
        stroke="#0A4763"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M49.3066 49.8959L58.8371 64.1945L78.0007 32.7861"
        stroke="#0A4763"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
